import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const [currentTagline, setCurrentTagline] = useState(0);
  const taglines = ["SAP", "Data", "Gen AI"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTagline((prev) => (prev + 1) % taglines.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="header-container">
      <div className="header-inner">
        {/* Logo Section */}
        <div className="logo-section">
          <img
            src="/assets/Ens_logo1.png"
            alt="Ensuresap Logo"
            className="logo-img"
          />
          <div className="logo-text">
            <span className="logo-title">ENSURESAP</span>
            <span className="logo-tagline">
              {"CONSULTING. "}
              <span className="animated-tagline">{taglines[currentTagline]}</span>
            </span>
          </div>
        </div>

        {/* Hamburger Menu for Mobile */}
        <button className="menu-toggle" onClick={handleMenuToggle} aria-label="Toggle Menu">
          ☰
        </button>

        {/* Navigation Links */}
        <nav className={`navigation ${menuOpen ? "open" : ""}`}>
          <Link to="/" className="nav-item" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/about-us" className="nav-item" onClick={() => setMenuOpen(false)}>About Us</Link>
          <Link to="/services" className="nav-item" onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/careers" className="nav-item" onClick={() => setMenuOpen(false)}>Careers</Link>
          <Link to="/contact-us" className="nav-item" onClick={() => setMenuOpen(false)}>Contact Us</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
